import { render } from "./InputIdentifyCanvas.vue?vue&type=template&id=20105198"
import script from "./InputIdentifyCanvas.vue?vue&type=script&lang=js"
export * from "./InputIdentifyCanvas.vue?vue&type=script&lang=js"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__